import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface AlertApiDialogData {
  message: string;
  errors: string;
  confirmButtonColor?: string;
}

@Component({
  selector: 'app-alert-api-dialog',
  templateUrl: './alert-api-dialog.html',
  styleUrls: ['./alert-api-dialog.scss'],
})
export class AlertApiDialog implements OnInit {
  confirmButtonColor: string = 'warn';

  constructor(
    public dialogRef: MatDialogRef<AlertApiDialog>,
    @Inject(MAT_DIALOG_DATA) public data: AlertApiDialogData
  ) {}

  ngOnInit() {
    if (this.data.confirmButtonColor) {
      this.confirmButtonColor = this.data.confirmButtonColor;
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
